export default __webpack_public_path__ + "static/media/sku-analysis-logo.1df75492.png";